import React from 'react';

interface GameContainerProps {
  onMiss: (e: React.TouchEvent | React.MouseEvent) => void;
  children: React.ReactNode;
}

const GameContainer: React.FC<GameContainerProps> = ({ onMiss, children }) => {
  return (
    <div 
      style={{ 
        height: '100vh', 
        position: 'relative',
        touchAction: 'none',
        WebkitTapHighlightColor: 'transparent',
        userSelect: 'none',
        WebkitUserSelect: 'none',
        msUserSelect: 'none',
        MozUserSelect: 'none',
        overflow: 'hidden',
      }}
      onTouchStart={onMiss}
      onMouseDown={onMiss}
    >
      {children}
    </div>
  );
};

export default GameContainer; 